import { GithubLogo, LinkedinLogo, WhatsappLogo } from "@phosphor-icons/react";

export const profile = {
  name: "Shamvil Kv",
  role: "Lead Full Stack Developer",
  current: "Lead Full Stack Developer, Mohammed Bin Haider Holding Group",
  statement:
    "I build scalable, data-driven and AI‑enabled products end to end, and I lead the teams that ship them.",
  email: "shamvilkv@gmail.com",
  whatsapp: "https://api.whatsapp.com/send?phone=919961983698&text=Hi",
  linkedin: "https://www.linkedin.com/in/shamvilkv",
  github: "https://github.com/shamvilkv",
  /** Scrubbed word by word in the About section. */
  headline:
    "Seven years building AI‑enabled web and mobile products, now leading full-stack teams in Dubai. One food-delivery platform past 50,000 downloads.",
  about:
    "I work across React, TypeScript, Node.js, Python and cloud-native architecture, turning complex business requirements into products that hold up in production. Lately that means AI: an HRM platform with OCR onboarding, an ML bird-detection system and a smart last-mile delivery product.",
  facts: [
    { label: "Based in", value: "Dubai, UAE" },
    { label: "Education", value: "BE Computer Science, VTU, 2015-2019" },
    { label: "Languages", value: "English, Malayalam, Hindi, Arabic" },
  ],
};

export const links = [
  { title: "GitHub", href: profile.github, icon: GithubLogo },
  { title: "LinkedIn", href: profile.linkedin, icon: LinkedinLogo },
  { title: "WhatsApp", href: profile.whatsapp, icon: WhatsappLogo },
];

export const navItems = [
  { label: "Work", hash: "#work" },
  { label: "Experience", hash: "#experience" },
  { label: "Skills", hash: "#skills" },
  { label: "Contact", hash: "#contact" },
];
